"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Span = exports.Text = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Text = styled_components_1.default.p `
  margin-bottom: 10px;
`;
exports.Span = styled_components_1.default.span `
  font-weight: 500;
`;
